export default __webpack_public_path__ + "static/media/left-1.5e05b89d.svg";